module.exports = __webpack_public_path__ + "static/media/3get.dc44cbec.svg";